import { Language } from '@ha/intl';
import isAbsoluteUrl from 'ha/utils/isAbsoluteUrl';

export default function formatHrefURL(url = '/', lang: Language = Language.en) {
  // by default in the url the language is english, and we don't
  // prepend the language for those urls.
  return isAbsoluteUrl(url) || lang === Language.en ? url : `/${lang}${url}`;
}
